import { Enums, Events } from "../../../thor.enums";
import M from "materialize-css";

export class ImportOnlineDialogController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "importOnlineMedia",
        "importOnlinePasserelle",
        "importOnlineSaleItems"
    ];

    public title: string;
    public gauges;
    public importStep: Enums.ImportItemStep = Enums.ImportItemStep.NotStarted;
    public progress;
    public summary;
    public summaryTemplate;
    public ImportItemStep = Enums.ImportItemStep;

    // bind from parent (AddOnlineItemController::_createUploadDialog)
    private container: any;
    private engineData: any;
    private engineType: string;

    private action;
    private addNewItemsOnly: boolean;
    private keepItemsAfterImport: boolean;

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        private importMedia,
        private importPasserelle,
        private importSaleItems
    ) {
        this.$t = $translate.instant;

        this.addNewItemsOnly =
            this.container.resource?.saleStarted &&
            [Enums.SaleStatus.Published, Enums.SaleStatus.Edited].includes(this.container.resource?.status);
        this.keepItemsAfterImport = this.addNewItemsOnly;
        this.progress = 0;

        if (this.container && this.engineData && this.engineType) {
            this.prepareEngine();
            if (this.action && this.importStep !== Enums.ImportItemStep.WaitForUserAction) {
                this.engine();
            }
        }
    }

    public finish() {
        if (this.importStep === Enums.ImportItemStep.Importing) {
            return;
        }
        this.$mdDialog.hide();
        this.$rootScope.$broadcast(Events.OnlineItemCreated);
    }

    public engine() {
        this.$log.info(`Import start to SaleId : ${this.container.id}`);

        this.importStep = Enums.ImportItemStep.Importing;

        this.importPasserelle.addNewItemsOnly = this.addNewItemsOnly;
        this.importPasserelle.keepItemsAfterImport = this.keepItemsAfterImport;

        this.action()
            .catch(error => {
                this.$log.error(`Error while importing ${this.engineType}`, error);
            })
            .finally(
                () => {
                    angular.element(document).ready(() => {
                        const elems = document.querySelectorAll(".collapsible");
                        M.Collapsible.init(elems, {});
                    });

                    this.importStep = Enums.ImportItemStep.Finished;
                    return this.container.fetchAll();
                },
                notification => {
                    this.onNotify(notification);
                }
            );
    }

    private prepareEngine() {
        this.title = "";
        this.action = null;
        this.summaryTemplate = null;
        this.gauges = {};

        if (this.engineType === "medias") {
            this.title = this.$t("import_a_partir_de_photos");
            this.action = this.importMedia.engine.bind(this.importMedia, this.container, this.engineData);
            this.summaryTemplate = "import-online-media-summary";
            this.gauges = {
                medias: {
                    icon: "insert_photo",
                    counter: {
                        total: this.engineData.length,
                        valid: 0,
                        error: 0
                    }
                }
            };
        } else if (this.engineType === "zipPasserelle" || this.engineType === "xmlPasserelle") {
            this.title = this.$t("import_pv2");
            this.summaryTemplate = "import-online-passerelle-summary";
            this.gauges = {
                medias: {
                    icon: "insert_photo",
                    counter: {
                        total: 0,
                        valid: 0,
                        error: 0
                    }
                },
                items: {
                    icon: "insert_drive_file",
                    counter: {
                        total: 0,
                        valid: 0,
                        error: 0
                    }
                },
                extraItems: {
                    icon: "delete",
                    counter: {
                        total: 0,
                        valid: 0,
                        error: 0
                    }
                }
            };

            if (this.container.items.length > 0) {
                this.importStep = Enums.ImportItemStep.WaitForUserAction;
            }
        }

        if (this.engineType === "csvSaleItems") {
            this.title = this.$t("import_a_partir_d_un_csv");
            this.action = this.importSaleItems.engine.bind(this.importSaleItems, this.container, this.engineData);
            this.summaryTemplate = "import-sale-items-summary";

            this.gauges = {
                rows: {
                    icon: "insert_drive_file",
                    counter: {
                        total: 0,
                        valid: 0,
                        error: 0
                    }
                }
            };
        }

        if (this.engineType === "zipPasserelle") {
            this.action = this.importPasserelle.engineZipFile.bind(
                this.importPasserelle,
                this.container,
                this.engineData
            );
        }

        if (this.engineType === "xmlPasserelle") {
            this.action = this.importPasserelle.engineXmlFile.bind(
                this.importPasserelle,
                this.container,
                this.engineData
            );
        }
    }

    private onNotify(notification) {
        switch (notification.action) {
            case "incrementGauge":
                this.incrementGauge(notification.data);
                break;
            case "setGauge":
                this.setGauge(notification.data);
                break;
            case "setSummary":
                this.summary = notification.data;
                break;
            default:
                this.$log.error(`onNotify:: action: ${notification.action} is not implemented`);
                break;
        }
    }

    private incrementGauge(data) {
        const increment = data.increment || 1;
        this.gauges[data.gauge].counter[data.counter] += increment;
        this.updateProgress();
    }

    private setGauge(data) {
        this.gauges[data.gauge].counter[data.counter] = data.value;
        this.updateProgress();
    }

    private updateProgress() {
        let denominator = 0;
        let numerator = 0;
        for (const gaugeName in this.gauges) {
            if (this.gauges.hasOwnProperty(gaugeName) && this.gauges[gaugeName]) {
                const counter = this.gauges[gaugeName].counter;
                denominator += counter.total;
                numerator += counter.valid + counter.error;
            }
        }

        let progress = Math.ceil((100 * numerator) / denominator);
        if (progress > 100) {
            progress = 100;
        }
        this.progress = progress;
    }
}
